import parse from 'date-fns/parse'

import { instance } from '@/api/instances'

const createTestResultFile = async (store, body) => {
  try {
    return await instance.post(`persons/${body.personId}/test_result_file`, {
      json: body
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'laboratoryTextUploadResult/createTestResultFile'
      },
      { root: true }
    )
  }
}

const addLaboratoryTestUploadResults = async (
  { dispatch },
  { personId, description, performedAt, file }
) => {
  try {
    const fileVaultResponse = await dispatch(
      'file/uploadFileByDomain',
      {
        file,
        personId,
        domain: 'ehr'
      },
      { root: true }
    )

    await dispatch('createTestResultFile', {
      personId,
      performedAt: parse(performedAt, 'yyyy-MM-dd', new Date())
        .toISOString()
        .replace('Z', ''),
      description,
      file: fileVaultResponse
    })
    return true
  } catch (error) {
    dispatch(
      'errors/setError',
      { message: `Erro ao fazer upload do arquivo ${description}` },
      { root: true }
    )
    return false
  }
}

export default {
  addLaboratoryTestUploadResults,
  createTestResultFile
}
